import { render } from "./ContactsTemplate.vue?vue&type=template&id=5ad4335d"
import script from "./ContactsTemplate.vue?vue&type=script&lang=js"
export * from "./ContactsTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__